import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import YouTube from "react-youtube";

import queryString from "querystring";

import { Image, Spin } from "antd";
import moment from "moment";

import partnersApi from "../../apis/Partners.api";
import ChannelCommentComponent from "../../components/channel/comment/ChannelCommentComponent";
import CommunityFavorite from "../../components/channel/community/CommunityFavorite";
import YoutubeComponent from "../../components/channel/YoutubeComponent";
import { setLoading } from "../../redux/store/common/commonDuck";

const CommunityEach = (props) => {
	const dispatch = useDispatch();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));
	const cUser = useSelector((state) => state.auth.channelUser);
	const [item, setItem] = useState({});

	const queryJson = queryString.parse(window.location.search?.replace("?", ""));
	const whereShow = queryJson?.whereShow;

	const handleLoad = () => {
		const scrollToComment = sessionStorage.getItem("comment-scroll");
		if (!window.scrollY) {
			const commentScroll = document.getElementById(
				"community-comment-favorite-id"
			);
			if (!!item?.id && !!scrollToComment) {
				window.scrollTo({
					// top: 0,
					top: commentScroll?.offsetTop,
					// behavior: 'smooth'
				});
				sessionStorage.removeItem("comment-scroll");
			}
		}
	};

	useEffect(() => {
		let community_id = props.match?.params?.id;
		if (community_id) {
			getCommunity(community_id);
		}
	}, [props, cUser]);

	const getCommunity = async (id) => {
		setIsLoading(true);
		try {
			let param = {
				influencerId: reduxChannel?.user_id,
				communityId: id,
				userId: cUser?.id ? cUser.id : 0,
				pageType: "user",
			};
			const res = await partnersApi.readCommunityEach(param);
			if (res.code === 200) {
				setItem(res.result);
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		} catch (e) {
			console.log(e);
		}
		setIsLoading(false);
	};

	return (
		<div
			className={`channel-wrap channel-home channel-delay`}
			onLoad={handleLoad}
		>
			<div className={`home-body`} style={{ gap: 0 }}>
				{isLoading && (
					<Spin
						style={{
							margin: "auto",
							width: "100%",
							paddingTop: "2em",
							position: "absolute",
							left: 0,
							right: 0,
						}}
					/>
				)}
				<div className={`max-width-apply`}>
					<div
						className={`home-community-each modal-community community-each-page`}
					>
						<div className={`home-community-content`}>
							<div className={`community-title-div `}>
								<p
									className={`community-tag`}
									style={{ backgroundColor: `${item?.background_color}` }}
								>
									{item?.category_name}
								</p>
								<p className={`community-title`}>{item?.title}</p>
							</div>
							<CommunityFavorite item={item} type={"header"} />
							{/*<div className={`community-footer-div`}>*/}
							{/*    <p>*/}
							{/*        좋아요 {item?.like_num ?? 0}*/}
							{/*    </p>*/}
							{/*    <p>·</p>*/}
							{/*    <p>*/}
							{/*        댓글 {item?.comment_num ?? 0}*/}
							{/*    </p>*/}
							{/*    <p>·</p>*/}
							{/*    <p>*/}
							{/*        조회*/}
							{/*        /!*{item?.view_num ?? 0}*!/*/}
							{/*        {Math.ceil(item?.view_num * (5 + (item?.id % 10 / 10)))}*/}
							{/*    </p>*/}
							{/*    <p>·</p>*/}
							{/*    <p>*/}
							{/*        {moment(item?.created_at).format("YYYY.MM.DD")}*/}
							{/*    </p>*/}
							{/*</div>*/}
							{item?.body?.includes("<p") ? (
								<div
									className={`community-body-div`}
									dangerouslySetInnerHTML={{
										__html: item?.body,
									}}
								/>
							) : (
								<div className={`community-body-div`}>
									{/*<YoutubeComponent*/}
									{/*    videoId={`adBe7YESvrs`}*/}
									{/*/>*/}
									<p>{item?.body}</p>
									{/*<p className={`body-detail`}>*/}
									{/*    ...자세히보기*/}
									{/*</p>*/}
								</div>
							)}
						</div>
						<div className={`home-community-image`}>
							{!!item?.communityImageList?.length && (
								<Image.PreviewGroup className={`preview-groups`}>
									{item?.communityImageList?.map((img, index) => (
										<Image
											preview={{
												// visible: false,
												mask: <></>,
												// current: index,
												// countRender: (c,t) => console.log(c, t)
											}}
											key={`list-img-${index}`}
											src={`${process.env.REACT_APP_S3_HOST}/image/together/community/${reduxChannel?.user_id}/${img?.title}.${img?.img_type}`}
											onError={({ currentTarget }) => {
												currentTarget.onerror = null; // prevents looping
												// currentTarget.style.display = "none";
												currentTarget.src = `/assets/images/no-product.png`;
											}}
											alt={`게시판 이미지`}
											style={{
												height: "auto",
												width: "100%",
											}}
										/>
									))}
								</Image.PreviewGroup>
							)}
						</div>
					</div>
				</div>

				<div
					className={`product-body max-width-apply community-each-comment`}
					style={{
						margin: "1.5em 0px",
						gap: "1em",
					}}
					id={`community-comment-favorite-id`}
					// onLoad={handleLoad}
				>
					<CommunityFavorite item={item} />
					<ChannelCommentComponent
						detail={item}
						type={"community"}
						getCommunity={() => getCommunity(item?.id)}
						whereShow={whereShow}
					/>
				</div>
			</div>
		</div>
	);
};
export default CommunityEach;
